module.exports = __webpack_public_path__ + "img/2919596-13-5.c02dd11d.png";